import React from 'react';
import { BotIcon, CubeIcon, IconSizes } from '@newcore/icons';

interface IconProps {
  className?: string;
}

export const AllAppsIcon: React.FC<IconProps> = ({ className }) => (
  <CubeIcon size={IconSizes.LG} className={className} aria-label='Your Apps' />
);

export const AgentsIcon: React.FC<IconProps> = ({ className }) => (
  <BotIcon size={IconSizes.LG} className={className} aria-label='Agents' />
);
